module.exports = __webpack_public_path__ + "static/media/memoir.8f063973.png";